import { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"
import { PORTFOLIO } from "../../shapes"
import "./style.scss"

class PortfolioSelector extends Component {
  constructor(...args) {
    super(...args)

    this.state = { open: false }
  }

  static propTypes = {
    portfolioName: PropTypes.string.isRequired,
    latestPortfolios: PropTypes.arrayOf(PORTFOLIO).isRequired,
  }

  toggle = () => {
    this.setState(state => ({ open: !state.open }))
  }

  render() {
    const { open } = this.state
    const { portfolioName, latestPortfolios } = this.props

    return <div className={classnames("portfolio-selector", { open })} onClick={this.toggle}>
      <div className="current-name">
        <span title={portfolioName}>{portfolioName}</span>
        <i className="fa fa-caret-down" />
      </div>
      <div className="dropdown">
        <div className="title" onClick={(e) => e.stopPropagation()}>Recently viewed...</div>
        {latestPortfolios.map(portfolio =>
          <Link key={portfolio.id} to={portfolio.to}>
            <span className="name">{portfolio.name}</span>
            <span className="model">{portfolio.model}</span>
          </Link>,
        )}
      </div>
    </div>
  }
}

export default PortfolioSelector
